import React from "react";

const sizes = {
  xs: "text-sm font-normal leading-[120%]",
  lg: "text-4xl font-normal",
  s: "text-xl font-normal",
  md: "text-2xl font-medium",
};

const Text = ({ children, className = "", as, size = "md", ...restProps }) => {
  const Component = as || "p";

  return (
    <Component className={`text-gray-800 font-poppins ${className} ${sizes[size]}`} {...restProps}>
      {children}
    </Component>
  );
};

export { Text };
